import * as React from 'react';

export default function Icon(props) {
  const {url, platform, target, rel, ariaLabel} = props;

  if (!platform || `${platform}`.trim() === '' || !url || `${url}`.trim() === '') {
    return null;
  }

  // Always force noopener/noreferrer on _blank links so a missing rel can never
  // reintroduce reverse-tabnabbing, regardless of the caller.
  const safeRel = target === '_blank'
    ? Array.from(new Set([...(rel || '').split(/\s+/).filter(Boolean), 'noopener', 'noreferrer'])).join(' ')
    : rel;

  return (
    <div className={`social-channel-icon social-channel-icon--${platform}`}>
      <a href={url} target={target} rel={safeRel} aria-label={ariaLabel}></a>
    </div>
  );
}
